import { ResponsiveBar } from "@nivo/bar";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Card } from "../../../components/Card";
import { numberFormatter } from "../../../utils";

const BUSINESS_INTERRUPTION_CHART_COLORS = Object.freeze({
  "Wildfire": "hsla(212.03, 46.46%, 50.2%, 1)",
  "Flood": "hsla(334.52,90.12%,68.24%,1)",
  "Cyclone": "hsla(298.75,45.71%,41.18%,1)",
  "Heatwave": "hsla(14.62,89.66%,65.88%,1)",
});

function BusinessInterruptionChart({ data }) {
  return (
    <Flex display={"block"} height={400} width={"100%"}>
      <ResponsiveBar
        data={data}
        keys={["Heatwave", "Cyclone", "Flood", "Wildfire"]}
        indexBy="name"
        margin={{ top: 50, right: 100, bottom: 50, left: 100 }}
        padding={0.3}
        groupMode="stacked"
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={item => BUSINESS_INTERRUPTION_CHART_COLORS[item.id]}
        borderColor={{
          from: "color",
          modifiers: [
            [
              "darker",
              1.6
            ]
          ]
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 0,
          tickPadding: 20,
          legendPosition: "middle",
          legendOffset: 40,
          tickRotation: 0
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legendPosition: "middle",
          legend: "Days of business interruption",
          legendOffset: -50,
          format: value => numberFormatter(value, 2)
        }}
        enableLabel={false}
        tooltip={tooltipObj => {
          const dataMidIdx = data?.length > 0 ? Math.round(data.length / 2) : null;
          const { label, value } = tooltipObj;
          const formattedValue = value && value > 0 ?
            value.toLocaleString("en-GB", { maximumFractionDigits: 2 }) : "";

          return (
            <Box position="relative">
              <Card
                position="absolute"
                left={dataMidIdx && tooltipObj && tooltipObj.index < dataMidIdx ? "100%" : null}
                right={dataMidIdx && tooltipObj && tooltipObj.index >= dataMidIdx ? "100%" : null}
                minWidth={"250px"}
                padding={3}
              >
                <Text fontSize="sm">
                  {label}: <b>{formattedValue}</b>
                </Text>
              </Card>
            </Box>);
        }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "top-right",
            direction: "column",
            justify: false,
            translateX: 60,
            translateY: 50,
            itemsSpacing: 10,
            itemWidth: 50,
            itemHeight: 40,
            itemDirection: "left-to-right",
            itemOpacity: 0.85,
            symbolShape: "circle",
            symbolSize: 20
          }
        ]}
        role="application"
      />
    </Flex>
  )
}

export default BusinessInterruptionChart;